import { FC } from "react";
import Stack from "../components/stack";
import Intro from "./intro";
import About from "./about";
import Responsive from "../components/responsive";
import Anchor from "../components/anchor";
import Body from "../components/body";
import Music from "../components/music";
import Track from "../assets/song.mp3";
import Ticker from "../components/ticker";
import Collectable from "./collectable";

const TickerIcon: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Body
      size="L"
      localStyles={{
        padding: "0 16px 0 48px",
        "@media (min-width: 600px)": {
          padding: "0 16px 0 72px",
        },
        "@media (min-width: 1080px)": {
          padding: "0 16px 0 112px",
        },
      }}
    >
      {children}
    </Body>
  );
};

const TickerContent: FC = () => {
  return (
    <>
      <TickerIcon>🚨</TickerIcon>
      <Body size="S">
        <strong>UnicornUDF</strong> on x.com is a SCAM, repeatedly launching
        fake tokens.
      </Body>
      <TickerIcon>🦄</TickerIcon>
      <Body size="S">
        Ron made it clear he will NEVER create new meme coins.{" "}
        <Anchor
          size="S"
          localStyles={{ color: " var(--anchor)" }}
          href="https://www.youtube.com/live/jsYmvPVCcTQ?si=ejT4U71EsP3_JJ_5&t=1328"
        >
          Watch the Update
        </Anchor>
      </Body>
      <TickerIcon>⛔</TickerIcon>
      <Body size="S">
        Unicorn Fart Dust has <strong>No Telegram Account</strong>.
      </Body>
      <TickerIcon>📢</TickerIcon>
      <Body size="S">
        UFD is born out of FUD!{" "}
        <Anchor
          size="S"
          localStyles={{ color: " var(--anchor)" }}
          href="https://www.youtube.com/live/NC6IX9W6Pfc?si=yjnLTFbtHCl6ooIR"
        >
          Watch the Update
        </Anchor>
      </Body>
      <TickerIcon>⛔</TickerIcon>
      <Body size="S">
        Unicorn Fart Dust has <strong>No Discord</strong>!
      </Body>
    </>
  );
};

export const Home: FC<{}> = () => {
  return (
    <>
      <Music track={Track} />
      <Ticker duration={43000}>
        <TickerContent />
        <TickerContent />
      </Ticker>

      <Responsive below={1599}>
        <Stack direction="VERTICAL" space="0">
          <Intro />
          <About />
        </Stack>
        <Collectable />
      </Responsive>
      <Responsive above={1600}>
        <Stack direction="HORIZONTAL" space="0">
          <Intro />
          <About />
        </Stack>
        <Collectable />
      </Responsive>
    </>
  );
};

export default Home;
